module.exports = __webpack_public_path__ + "img/wandian.97c84ad1.png";